var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1GridOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,80c0-26.51,21.49-48,48-48h352c26.5,0,48,21.49,48,48v96c0,26.5-21.5,48-48,48H48c-26.51,0-48-21.5-48-48v-96ZM32,80v96c0,8.8,7.16,16,16,16h352c8.8,0,16-7.2,16-16v-96c0-8.84-7.2-16-16-16H48c-8.84,0-16,7.16-16,16ZM0,336c0-26.5,21.49-48,48-48h352c26.5,0,48,21.5,48,48v96c0,26.5-21.5,48-48,48H48c-26.51,0-48-21.5-48-48v-96ZM32,336v96c0,8.8,7.16,16,16,16h352c8.8,0,16-7.2,16-16v-96c0-8.8-7.2-16-16-16H48c-8.84,0-16,7.2-16,16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1GridOutline);
export default __webpack_public_path__ + "static/media/1-grid-outline.09046a3d37d2f8e6625c7ef2d9df8e60.svg";
export { ForwardRef as ReactComponent };